import { memo, useCallback } from "react";

import { type Splide, type SlideComponent } from "@splidejs/splide";

import { useCarouselAria } from "@react/a11y/carouselAria";
import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { type ProductHeroSettings } from "@root/tablescape/state";

import { UGCVideoCarouselView } from "./UGCVideoCarousel.view";

const UGCVideoCarouselBase = () => {
  const {
    ugcVideoCarousel: { heading, text, videos },
  } = useSectionSettings<ProductHeroSettings>();

  const playVideo = useCallback((_splide: Splide, slide: SlideComponent) => {
    slide?.slide.querySelector("video")?.play();
  }, []);

  const pauseVideo = useCallback((_splide: Splide, slide: SlideComponent) => {
    const video = slide?.slide.querySelector("video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }, []);

  const carouselAria = useCarouselAria({
    label: "User generated content videos",
    totalSlides: videos.length,
  });

  if (!videos.length) {
    return null;
  }

  return (
    <UGCVideoCarouselView
      carouselAria={carouselAria}
      heading={heading}
      pauseVideo={pauseVideo}
      playVideo={playVideo}
      text={text}
      videos={videos}
    />
  );
};

export const UGCVideoCarousel = memo(UGCVideoCarouselBase);
